import React from 'react'

import {
  FieldSpec,
  LinkedField,
  LinkedPathField,
  PaginatedTable,
  PercentField,
  ValueField,
} from 'src/components/Table'
import { ListTableProps } from './types'

const fieldOptions: {[key: string]: FieldSpec} = {
  place: {id: 'place.name', label: 'Diff for', ordering: 'place__name', renderer: LinkedField(ValueField)},
  path: {id: 'place.objPath', label: 'Place', ordering: 'place__search_path', renderer: LinkedPathField},
  over: {id: 'over', label: 'SKUit is Over', ordering: 'over_count', renderer: ValueField},
  under: {id: 'under', label: 'SKUit is Under', ordering: 'under_count', renderer: ValueField},
  matched: {id: 'match', label: 'SKUit and Audit Matched', ordering: 'match_count', renderer: ValueField},
  accuracyScore: {id: 'accuracyScore', label: 'Accuracy Score', renderer: PercentField},
}

export const AuditResultPlaceListTable = (props: ListTableProps) => {
  const {paginator, fields, extraActions, extraRowActions, exportConfig, title="Audit Diff"} = props

  return (
    <>
      <PaginatedTable
        title={title}
        fields={fields.map((field) => fieldOptions[field])}
        paginator={paginator}
        actions={extraActions}
        rowActions={extraRowActions}
        exportConfig={exportConfig}
      />
    </>
  )
}
